module.exports = __webpack_public_path__ + "static/media/Prisma-Access-Logo.c146ee39.svg";